import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class SettingsApiService {
  private api = inject(VwApiRequestsService);

  get() {
    return this.api.getAPICall('/settings');
  }

  update(payload: { globalTrackingMode?: string; shiftStart?: string; shiftEnd?: string; behindTargetAlertThresholdPct?: number }) {
    return this.api.postAPICall('/settings', payload);
  }

  addGenericDowntimeReason(name: string) {
    return this.api.postAPICall('/settings/generic-downtime-reasons', { name });
  }

  deleteGenericDowntimeReason(reasonId: string) {
    return this.api.postAPICall(`/settings/generic-downtime-reasons/${reasonId}/delete`, {});
  }
}
